<template>
  <img src="@/assets/img/Icons/Electric.svg" />
</template>

<script>
export default {}
</script>

<style></style>
